import { PropsWithChildren } from 'react'
import { Schemas } from '~/api/gen'
import { Button } from '~/components/elements/Button'
import { ALERT_TEXT_FOLLOW_NOT_ALLOWED } from '~/features/shared/memberDetail/constants'
import { useBkurl } from '~/hooks/useBkurl'
import { useIsLoggedIn } from '~/hooks/useIsLoggedIn'
import { useRelationship } from '~/hooks/useRelationship'

type ButtonWrapperProps = { color?: 'primary' | 'red'; onClick?: () => void }
const ButtonWrapper: React.FC<PropsWithChildren<ButtonWrapperProps>> = ({
  color = 'primary',
  onClick,
  children,
}) => {
  return (
    <div className="w-[134px]">
      <Button color={color} onClick={onClick}>
        <span className="block pb-3 pt-[10px] font-bold">{children}</span>
      </Button>
    </div>
  )
}

type Member = Pick<Schemas.member_large, 'id' | 'user_name'>

type FollowButtonProps = {
  member: Member
}

export const DeprecatedFollowButton: React.FC<FollowButtonProps> = ({
  member,
}) => {
  const isLoggedIn = useIsLoggedIn()
  const bkurl = useBkurl()
  const { following, blocked, follow, unfollow } = useRelationship(member)

  return (
    <div className="ml-auto mt-1">
      {following ? (
        <ButtonWrapper color="red" onClick={following ? unfollow : follow}>
          フォロー中
        </ButtonWrapper>
      ) : (
        <ButtonWrapper
          onClick={() => {
            if (blocked) {
              alert(ALERT_TEXT_FOLLOW_NOT_ALLOWED)
              return
            }
            if (!isLoggedIn) {
              location.href = `/login/?bkurl=${bkurl}`
              return
            }
            if (following) {
              unfollow()
              return
            }
            follow()
          }}
        >
          フォローする
        </ButtonWrapper>
      )}
    </div>
  )
}
